import {Model} from "./base/Model";
import {BaseModel} from "./Base";
import { ICustomer, CustomerModel } from "./Customer"
import { TenantSectors } from "./TenantSectors"


    export interface ITenant {
      name: string,
      email: string,
      customer: ICustomer,
    }

    
    export class TenantModel extends BaseModel {
        key:string = "";
        name:String = "";
        schema:String = "";
        db:String = "";
        fields:any = {};
        sectors:any = {};
        
        constructor(data = null) {
            super();
                if(data) {
                    this.key = data.key;
                    this.name = data.name;
                    this.schema = data.schema;
                    this.db = data.db;
                    
                    
                    for(let i in data.ppc_tenant_fields) {
                        let fieldKey = data.ppc_tenant_fields[i].fieldkey;
                        this.fields[fieldKey] = Object.assign({}, data.ppc_tenant_fields[i].data);
                    }
                    //this.ppc_tenant_fields = data.ppc_tenant_fields;
                } else {
                    this.sectors = new TenantSectors();
                }
        }
        
    }

    export class TenantCompanyModel extends CustomerModel  {
      tenant:TenantModel = new TenantModel();
      
      constructor(data = null, tenant = null) {
          super(data);
          
          if(tenant) {
              this.tenant = new TenantModel(tenant);

          }
          
          //this.createAddress()
      }
    }